<ng-container *ngIf="formGroup">
    <div [formGroup]="formGroup">
        <div class="divider bg-dark mt-0 mb-3"></div>
        <h3 class="text-center">General</h3>
        <div>
            <h4>Customer</h4>
            <div class="row mb-4">
                <div class="col">
                    <app-form-input label="First Name" [formControl]="formGroup.controls.firstName"></app-form-input>
                </div>
                <div class="col">
                    <app-form-input label="Last Name" [formControl]="formGroup.controls.lastName"></app-form-input>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col">
                    <app-form-input label="Phone Number" [formControl]="formGroup.controls.phone"></app-form-input>
                </div>

                <div class="col">
                    <app-form-input label="Email Address" type="email" [formControl]="formGroup.controls.email"></app-form-input>
                </div>
                <div class="col" *ngIf="formGroup.controls.dateOfBirth.enabled">
                    <app-form-datepicker
                        label="Date of Birth"
                        [formControl]="formGroup.controls.dateOfBirth"
                    ></app-form-datepicker>
                </div>
            </div>
        </div>
        <div formArrayName="addresses">
            <div *ngFor="let address of addresses?.controls; let i = index" [formGroupName]="i">
                <app-forms-address
                    [class.d-none]="address.disabled"
                    [formGroup]="address"
                    [title]="i === 0 ? 'Customer Address' : 'Customer Previous Address'"
                ></app-forms-address>
            </div>
        </div>

        <ng-container *ngIf="employmentHistories?.enabled">
            <div class="divider bg-dark mt-5 mb-3"></div>
            <h3 class="text-center">Employment History</h3>
            <div formArrayName="employment_histories">
                <div *ngFor="let history of employmentHistories?.controls; let i = index" [formGroupName]="i">
                    <app-forms-employment-history
                        [class.d-none]="history.disabled"
                        [formGroup]="history"
                        [title]="i === 0 ? 'Current Employment' : 'Previous Employment'"
                        [addressTitle]="i === 0 ? 'Current Employment Address' : 'Previous Employment Address'"
                    ></app-forms-employment-history>
                </div>
            </div>
        </ng-container>

    </div>
</ng-container>
